import UtilService from 'services/util';
import { GET_GRID_COLUMNS} from '../constants/apiConstant';
import { LOCAL_STORAGE_VAR } from '../constants/Common';

export const fetchGridColumns = (obj) => {
  return new Promise((resolve, reject) => {
    UtilService.callApi(obj, (err, response) => {
      if (err) {
        reject(err);
      } else if (response && response.code === 'OK') {
        resolve(response.data.columns);
      } else {
        resolve([]);
      }
    });
  });
};

export const gridColumnLGD = async () => {
  const obj = { ...GET_GRID_COLUMNS, request: { name: 'GRID_DIAMOND_LIST_LGD' } };
  try {
    const columns = await fetchGridColumns(obj);
    localStorage.setItem(`${LOCAL_STORAGE_VAR}-lgd-column`, JSON.stringify(columns));
  } catch (error) {
    console.error('Failed to load LGD grid columns:', error);
  }
};

export const gridColumnND = async () => {
  const obj = { ...GET_GRID_COLUMNS, request: { name: 'GRID_DIAMOND_LIST' } };
  try {
    const columns = await fetchGridColumns(obj);
    localStorage.setItem(`${LOCAL_STORAGE_VAR}-column`, JSON.stringify(columns));
  } catch (error) {
    console.error('Failed to load ND grid columns:', error);
  }
};
